import { FC } from 'react';

import { LoginForm } from '@/modules/Auth';

interface Props {}

const LoginPage: FC<Props> = () => {
  return (
    <LoginForm/>
  );
};

export default LoginPage;
